export function validateCPF(cpf: string) {
  if (!cpf) return false;

  cpf = cpf.replace(/[^\d]+/g, "");
  const invalidCpfDefaults = [
    "00000000000",
    "11111111111",
    "22222222222",
    "33333333333",
    "44444444444",
    "55555555555",
    "66666666666",
    "77777777777",
    "88888888888",
    "99999999999"
  ];
  if (invalidCpfDefaults.includes(cpf)) {
    return false;
  }
  if (cpf.length !== 11) {
    return false;
  }

  let firstDigit;
  let secondDigit;

  let add = 0;
  for (let i = 0; i < 9; i++) {
    add += parseInt(cpf.charAt(i)) * (10 - i);
  }
  firstDigit = 11 - (add % 11);
  if (firstDigit === 10 || firstDigit === 11) {
    firstDigit = 0;
  }

  if (firstDigit !== parseInt(cpf.charAt(9))) {
    return false;
  }

  add = 0;
  for (let i = 0; i < 10; i++) {
    add += parseInt(cpf.charAt(i)) * (11 - i);
  }
  secondDigit = 11 - (add % 11);
  if (secondDigit === 10 || secondDigit === 11) {
    secondDigit = 0;
  }

  // Check the validation digit
  if (secondDigit !== parseInt(cpf.charAt(10))) {
    return false;
  }
  return true;
}

export function vlidateCPFFormt(cpf: string) {
  const regex = new RegExp(
    /^(\d{3})\.?(\d{3})\.?(\d{3})\-?(\d{2}$)$|^(\d{2})\.?(\d{3})\.?(\d{3})\/?([0-1]{4})\-?(\d{2})$/g
  );
  const isValidtedFormat = regex.test(cpf);
  return isValidtedFormat;
}
